import React from 'react';
import { TabbedShowLayout, Tab, TextField, BooleanField } from 'react-admin';

import Show from '../common/views/Show';
import DateFieldCustom from '../common/fields/DateField';
import CostFrequencyField from './fields/CostFrequencyField';

const CostShow = props => (
    <Show {...props}>
        <TabbedShowLayout>
            <Tab label="Summary">
                <TextField source="id" />
                <CostFrequencyField source="frequency" />
                <TextField source="name" />
                <TextField source="vendor" />
                <TextField source="category" />

                <TextField source="amount" />
                <TextField source="amount_min" />
                <TextField source="amount_max" />

                <TextField source="variation_pct" />
                <BooleanField source="is_variable" />

                <DateFieldCustom source="start_date" />
                <DateFieldCustom source="end_date" />
            </Tab>
        </TabbedShowLayout>
    </Show>
);

export default CostShow;
